var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { ref: "context", staticClass: "context" },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticClass: "title",
                  staticStyle: { "margin-right": "20px" },
                },
                [
                  _vm.otherRuleForm.channel != 1
                    ? _c(
                        "i",
                        {
                          staticStyle: { color: "red", "margin-right": "5px" },
                        },
                        [_vm._v("*")]
                      )
                    : _vm._e(),
                  _vm._v("商品款式图"),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                _vm._b(
                  { ref: "basicRuleForm", staticStyle: { flex: "1" } },
                  "el-form",
                  _vm.otherLayout,
                  false
                ),
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.otherLayout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: { prop: "pass" },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    disabled: "",
                                    "file-list": _vm.fileList,
                                    action: "#",
                                    "list-type": "picture-card",
                                    "on-preview": _vm.handlePictureCardPreview,
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-plus" })]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticClass: "title",
                  staticStyle: { "margin-right": "20px" },
                },
                [_vm._v("商品3D图")]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                _vm._b(
                  { ref: "basicRuleForm", staticStyle: { flex: "1" } },
                  "el-form",
                  _vm.otherLayout,
                  false
                ),
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.otherLayout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: { prop: "pass" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        disabled: "",
                                        "file-list": _vm.gifList,
                                        action: "#",
                                        "list-type": "picture-card",
                                        "on-preview":
                                          _vm.handlePictureCardPreview,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-left": "20px" } },
                                    _vm._l(_vm.gifList, function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "flex" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "line-height": "1",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm._f("name")(item))
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "basicInfo card" },
            [
              _c(
                "el-form",
                _vm._b(
                  {
                    ref: "basicRuleForm",
                    attrs: {
                      model: _vm.basicRuleForm,
                      rules: _vm.basicRules,
                      "label-width": "150px",
                    },
                  },
                  "el-form",
                  _vm.layout,
                  false
                ),
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "款号", prop: "styleNo" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.basicRuleForm.styleNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.basicRuleForm, "styleNo", $$v)
                                  },
                                  expression: "basicRuleForm.styleNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", label: "季节" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.basicRuleForm.season,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.basicRuleForm, "season", $$v)
                                    },
                                    expression: "basicRuleForm.season",
                                  },
                                },
                                _vm._l(_vm.seasonList, function (item, index) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: index,
                                      attrs: {
                                        label: _vm.multiLanguageDisplay(
                                          item.label
                                        ),
                                        value: item.dictValue,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.multiLanguageDisplay(
                                              item.dictValue
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", label: "年份" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.basicRuleForm.year,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.basicRuleForm, "year", $$v)
                                    },
                                    expression: "basicRuleForm.year",
                                  },
                                },
                                _vm._l(_vm.yearList, function (item, index) {
                                  return _c(
                                    "el-option",
                                    { key: index, attrs: { value: item } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户款号" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.basicRuleForm.customerStyleNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicRuleForm,
                                      "customerStyleNo",
                                      $$v
                                    )
                                  },
                                  expression: "basicRuleForm.customerStyleNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "供应商款号" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.basicRuleForm.supplierStyleCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicRuleForm,
                                      "supplierStyleCode",
                                      $$v
                                    )
                                  },
                                  expression: "basicRuleForm.supplierStyleCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "款式名称", required: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.multiLanguageDisplay(
                                    _vm.basicRuleForm.name
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "波段" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { allowClear: "" },
                                  model: {
                                    value: _vm.basicRuleForm.styleBand,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.basicRuleForm,
                                        "styleBand",
                                        $$v
                                      )
                                    },
                                    expression: "basicRuleForm.styleBand",
                                  },
                                },
                                _vm._l(_vm.bandList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.dictLabel,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "上市日期", prop: "onSaleDate" },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass: "picker",
                                model: {
                                  value: _vm.basicRuleForm.onSaleDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicRuleForm,
                                      "onSaleDate",
                                      $$v
                                    )
                                  },
                                  expression: "basicRuleForm.onSaleDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌", required: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.basicRuleForm.brand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.basicRuleForm, "brand", $$v)
                                    },
                                    expression: "basicRuleForm.brand",
                                  },
                                },
                                _vm._l(_vm.brandList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.dictLabel,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "类目", required: "" } },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  props: {
                                    label: "name",
                                    value: "classifyId",
                                    children: "children",
                                  },
                                  options: _vm.classificationList,
                                },
                                model: {
                                  value: _vm.classificationIdList,
                                  callback: function ($$v) {
                                    _vm.classificationIdList = $$v
                                  },
                                  expression: "classificationIdList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "织法", required: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.basicRuleForm.category,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.basicRuleForm,
                                        "category",
                                        $$v
                                      )
                                    },
                                    expression: "basicRuleForm.category",
                                  },
                                },
                                _vm._l(
                                  _vm.categoryList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.dictLabel,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "人群", required: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.basicRuleForm.appropriate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.basicRuleForm,
                                        "appropriate",
                                        $$v
                                      )
                                    },
                                    expression: "basicRuleForm.appropriate",
                                  },
                                },
                                _vm._l(
                                  _vm.appropriateList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.dictLabel,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "材质", prop: "material" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.multiLanguageDisplay(
                                    _vm.basicRuleForm.material
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.classificationId != 122
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "针种" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      model: {
                                        value: _vm.basicRuleForm.needleType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.basicRuleForm,
                                            "needleType",
                                            $$v
                                          )
                                        },
                                        expression: "basicRuleForm.needleType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.needleTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.dictLabel,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "克重(g/m²)" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.basicRuleForm.weight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.basicRuleForm,
                                          "weight",
                                          $$v
                                        )
                                      },
                                      expression: "basicRuleForm.weight",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "水洗", required: "" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        mode: "multiple",
                                        showArrow: "",
                                      },
                                      model: {
                                        value: _vm.basicRuleForm.washings,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.basicRuleForm,
                                            "washings",
                                            $$v
                                          )
                                        },
                                        expression: "basicRuleForm.washings",
                                      },
                                    },
                                    _vm._l(
                                      _vm.washingList,
                                      function (item, index) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: item.id,
                                            attrs: {
                                              label: _vm.multiLanguageDisplay(
                                                item.washingName
                                              ),
                                              value: item.id,
                                            },
                                          },
                                          [
                                            _c("div", { staticClass: "flex" }, [
                                              _c("img", {
                                                staticClass: "wash-img",
                                                attrs: {
                                                  src: item.washingUrl,
                                                  alt: "",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.multiLanguageDisplay(
                                                        item.washingName
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.classificationId != 122
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "服务" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        mode: "multiple",
                                        showArrow: "",
                                        allowClear: "",
                                      },
                                      model: {
                                        value:
                                          _vm.basicRuleForm
                                            .serviceManagementIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.basicRuleForm,
                                            "serviceManagementIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "basicRuleForm.serviceManagementIds",
                                      },
                                    },
                                    _vm._l(_vm.manage1, function (item, index) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: index,
                                          attrs: {
                                            label: _vm.multiLanguageDisplay(
                                              item.manageName
                                            ),
                                            value: item.id,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "flex" }, [
                                            _c("img", {
                                              staticClass: "wash-img",
                                              attrs: {
                                                src: item.imageUrl,
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.multiLanguageDisplay(
                                                      item.manageName
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "表现" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        mode: "multiple",
                                        showArrow: "",
                                        allowClear: "",
                                      },
                                      model: {
                                        value:
                                          _vm.basicRuleForm
                                            .performanceManagementIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.basicRuleForm,
                                            "performanceManagementIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "basicRuleForm.performanceManagementIds",
                                      },
                                    },
                                    _vm._l(_vm.manage2, function (item, index) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: index,
                                          attrs: {
                                            label: _vm.multiLanguageDisplay(
                                              item.manageName
                                            ),
                                            value: item.id,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "flex" }, [
                                            _c("img", {
                                              staticClass: "wash-img",
                                              attrs: {
                                                src: item.imageUrl,
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.multiLanguageDisplay(
                                                      item.manageName
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: _vm.layout.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "认证" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        mode: "multiple",
                                        showArrow: "",
                                        allowClear: "",
                                      },
                                      model: {
                                        value:
                                          _vm.basicRuleForm
                                            .certificationManagementIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.basicRuleForm,
                                            "certificationManagementIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "basicRuleForm.certificationManagementIds",
                                      },
                                    },
                                    _vm._l(_vm.manage3, function (item, index) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: index,
                                          attrs: {
                                            label: _vm.multiLanguageDisplay(
                                              item.manageName
                                            ),
                                            value: item.id,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "flex" }, [
                                            _c("img", {
                                              staticClass: "wash-img",
                                              attrs: {
                                                src: item.imageUrl,
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.multiLanguageDisplay(
                                                      item.manageName
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品详情" } },
                            [
                              _c("el-input", {
                                attrs: { type: "textarea", rows: 2 },
                                model: {
                                  value: _vm.basicRuleForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.basicRuleForm,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "basicRuleForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("其他信息")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "basicInfo card" },
            [
              _c(
                "el-form",
                _vm._b(
                  {
                    ref: "otherRuleForm",
                    attrs: { model: _vm.otherRuleForm, "label-width": "150px" },
                  },
                  "el-form",
                  _vm.layout,
                  false
                ),
                [
                  _vm._l(_vm.DynamicList, function (item, index) {
                    return _c(
                      "el-row",
                      { key: index },
                      _vm._l(item, function (citem, cindex) {
                        return _c(
                          "el-col",
                          { key: cindex, attrs: { span: _vm.layout.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: citem.newName,
                                  prop: citem.require,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.getDynamicValue(citem.newName),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", label: "单位" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.multiLanguageDisplay(
                                      _vm.otherRuleForm.unit
                                    ),
                                  },
                                },
                                _vm._l(_vm.unitList, function (item, index) {
                                  return _c(
                                    "el-option",
                                    { key: index, attrs: { value: item } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.multiLanguageDisplay(item)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "执行标准" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.otherRuleForm.execStandard,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.otherRuleForm,
                                      "execStandard",
                                      $$v
                                    )
                                  },
                                  expression: "otherRuleForm.execStandard",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "安全类别" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.otherRuleForm.securityLevel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "securityLevel",
                                        $$v
                                      )
                                    },
                                    expression: "otherRuleForm.securityLevel",
                                  },
                                },
                                _vm._l(
                                  _vm.securityLevelList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.dictLabel,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-row"),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "工艺要求" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.multiLanguageDisplay(
                                    _vm.otherRuleForm.craft
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开发款号" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.otherRuleForm.devCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.otherRuleForm, "devCode", $$v)
                                  },
                                  expression: "otherRuleForm.devCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _vm.showSeries
                            ? _c(
                                "el-form-item",
                                { attrs: { required: "", label: "系列" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { allowClear: "" },
                                      model: {
                                        value: _vm.otherRuleForm.series,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.otherRuleForm,
                                            "series",
                                            $$v
                                          )
                                        },
                                        expression: "otherRuleForm.series",
                                      },
                                    },
                                    _vm._l(
                                      _vm.seriesList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.label,
                                            value: item.dictValue,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", label: "交货方式" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { allowClear: "" },
                                  model: {
                                    value: _vm.otherRuleForm.channel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "channel",
                                        $$v
                                      )
                                    },
                                    expression: "otherRuleForm.channel",
                                  },
                                },
                                _vm._l(_vm.channelList, function (item, index) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否支持海外销售",
                                required: "",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.otherRuleForm.isSupportOverseas,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "isSupportOverseas",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "otherRuleForm.isSupportOverseas",
                                  },
                                },
                                _vm._l(
                                  _vm.supportOverseasList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "交易类型", required: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { multiple: "", allowClear: "" },
                                  model: {
                                    value: _vm.otherRuleForm.tradeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "tradeType",
                                        $$v
                                      )
                                    },
                                    expression: "otherRuleForm.tradeType",
                                  },
                                },
                                _vm._l(_vm.typeList, function (item, index) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "相关报告" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.otherRuleForm.reportList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "reportList",
                                        $$v
                                      )
                                    },
                                    expression: "otherRuleForm.reportList",
                                  },
                                },
                                _vm._l(
                                  _vm.testReportList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: _vm.multiLanguageDisplay(
                                          item.name
                                        ),
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.layout.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "电子色卡" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.otherRuleForm.eColorBookId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.otherRuleForm,
                                        "eColorBookId",
                                        $$v
                                      )
                                    },
                                    expression: "otherRuleForm.eColorBookId",
                                  },
                                },
                                _vm._l(_vm.eColorList, function (item, index) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: _vm.multiLanguageDisplay(
                                        item.name
                                      ),
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "成分", required: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "colorBox",
                                  staticStyle: {
                                    flex: "1",
                                    "align-items": "center",
                                  },
                                },
                                _vm._l(_vm.compositionList, function (v, k) {
                                  return _c(
                                    "div",
                                    { key: k, staticClass: "colorItem" },
                                    [
                                      _c("span", { staticClass: "colorMsg" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.multiLanguageDisplay(
                                                v.compositionName
                                              ) +
                                                (v.percent
                                                  ? v.percent + "%"
                                                  : "")
                                            ) +
                                            "\n                  "
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("颜色尺码")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "colorBox" },
                _vm._l(_vm.colorList, function (v, k) {
                  return _c(
                    "div",
                    { key: k, staticClass: "colorItem colorList" },
                    [
                      _c("span", {
                        staticClass: "grbColor",
                        style: { backgroundColor: v.value },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.multiLanguageDisplay(v.name))),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.isSupportSize
              ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
                  _c(
                    "div",
                    { staticClass: "titColor" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._l(_vm.newSizeList, function (item, index) {
                        return _c(
                          "el-button",
                          {
                            key: index,
                            staticClass: "btn",
                            attrs: {
                              type:
                                item.id == _vm.activeSize.id ? "primary" : "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onSize(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.multiLanguageDisplay(item.name)))]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "selectType" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { name: "radioGroup" },
                          on: { change: _vm.onSelectType },
                          model: {
                            value: _vm.activeSizeType,
                            callback: function ($$v) {
                              _vm.activeSizeType = $$v
                            },
                            expression: "activeSizeType",
                          },
                        },
                        _vm._l(_vm.checkSize, function (item, index) {
                          return _c(
                            "el-radio",
                            { key: index, attrs: { label: item.id } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.name) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sizeTbale" },
                    [
                      _vm.activeSizeType == 1 || !_vm.activeSizeType
                        ? _c(
                            "el-table",
                            {
                              ref: "multipleTable",
                              staticStyle: { width: "fit-content" },
                              attrs: {
                                "row-key": function (row) {
                                  return row["1"]
                                },
                                border: "",
                                data: _vm.sizeDataSource,
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.sizeColumns, function (item, index) {
                                return [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "" + item.key,
                                      label: item.title,
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeSizeType == 2
                        ? _c(
                            "el-table",
                            {
                              ref: "multipleTable2",
                              attrs: {
                                "row-key": function (row) {
                                  return row["1"]
                                },
                                border: "",
                                columns: _vm.sizeColumns,
                                data: _vm.sizeDataSource2,
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.sizeColumns, function (item, index) {
                                return [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "" + item.key,
                                      label: item.title,
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("商品规格")]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "specsList" },
              [
                _c(
                  "el-tabs",
                  {
                    on: { "tab-click": _vm.tabchange },
                    model: {
                      value: _vm.activeKey,
                      callback: function ($$v) {
                        _vm.activeKey = $$v
                      },
                      expression: "activeKey",
                    },
                  },
                  _vm._l(_vm.specListTab, function (item) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: item.colorId,
                        attrs: { label: item.name, name: "" + item.colorId },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.multiLanguageDisplay(
                                                item.name
                                              )
                                                ? _vm.multiLanguageDisplay(
                                                    item.name
                                                  )
                                                : item.name
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.code))]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mianImg specImg" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "title",
                                staticStyle: { "margin-right": "20px" },
                              },
                              [
                                _c("i", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("颜色主图"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  disabled: "",
                                  "file-list": item.mainImage,
                                  action: "#",
                                  "list-type": "picture-card",
                                  "on-preview": _vm.handlePictureCardPreview,
                                },
                              },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "subImg specImg",
                            staticStyle: { height: "127px" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "title",
                                staticStyle: { "margin-right": "20px" },
                              },
                              [
                                _c("i", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("颜色缩略图"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  disabled: "",
                                  "file-list": item.thumbImage,
                                  action: "#",
                                  "list-type": "picture-card",
                                  "on-preview": _vm.handlePictureCardPreview,
                                },
                              },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticStyle: { "margin-top": "50px" } },
                          [
                            _c("el-col", { attrs: { span: 10 } }, [
                              _c("div", { staticClass: "flex" }, [
                                _c("span", { staticStyle: { width: "10%" } }, [
                                  _vm._v("国内站"),
                                ]),
                                _vm._v(" "),
                                _vm.otherRuleForm.tradeType &&
                                _vm.otherRuleForm.tradeType.includes(0)
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    现货起订量：" +
                                            _vm._s(item.num)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.otherRuleForm.tradeType &&
                                _vm.otherRuleForm.tradeType.includes(1)
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    预售起订量：" +
                                            _vm._s(item.presaleNum)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.otherRuleForm.tradeType &&
                                _vm.otherRuleForm.tradeType.includes(2)
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    样品起订量：" +
                                            _vm._s(item.sampleNum)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          { attrs: { data: item.dataSource, border: "" } },
                          [
                            _vm._l(_vm.columns, function (item, index) {
                              return [
                                item.key == "profit"
                                  ? _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        prop: "" + item.key,
                                        label: item.title,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.changenewProfit(
                                                        scope.row
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : item.key == "ladd"
                                  ? _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        prop: "" + item.key,
                                        label: item.title,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onLadd(
                                                          scope.row,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("查看")]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _c("el-table-column", {
                                      attrs: {
                                        align: "center",
                                        prop: "" + item.key,
                                        label: item.title,
                                      },
                                    }),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.otherRuleForm.isSupportOverseas == 1
                          ? _c(
                              "el-row",
                              { staticStyle: { "margin-top": "30px" } },
                              [
                                _c("el-col", { attrs: { span: 7 } }, [
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "10%" } },
                                      [_vm._v("海外站")]
                                    ),
                                    _vm._v(" "),
                                    _vm.otherRuleForm.tradeType &&
                                    _vm.otherRuleForm.tradeType.includes(0)
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-right": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    现货起订量：" +
                                                _vm._s(item.num1)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.otherRuleForm.tradeType &&
                                    _vm.otherRuleForm.tradeType.includes(1)
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-right": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    预售起订量：" +
                                                _vm._s(item.presaleForeignNum)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.otherRuleForm.tradeType &&
                                    _vm.otherRuleForm.tradeType.includes(2)
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-right": "20px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    样品起订量：" +
                                                _vm._s(item.sampleForeignNum)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.otherRuleForm.isSupportOverseas == 1
                          ? _c(
                              "el-table",
                              {
                                attrs: {
                                  border: "",
                                  columns: _vm.columns2,
                                  data: item.dataSource2,
                                },
                              },
                              [
                                _vm._l(_vm.columns2, function (item, index) {
                                  return [
                                    item.key == "profit"
                                      ? _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            prop: "" + item.key,
                                            label: item.title,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.changenewProfit(
                                                            scope.row
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : item.key == "ladd"
                                      ? _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            prop: "" + item.key,
                                            label: item.title,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onLadd(
                                                              scope.row,
                                                              2
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("查看")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _c("el-table-column", {
                                          attrs: {
                                            align: "center",
                                            prop: "" + item.key,
                                            label: item.title,
                                          },
                                        }),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("库存")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 7 } }, [
                _c("div", { staticClass: "flex2" }, [
                  _c("div", [
                    _vm._v("款号：" + _vm._s(_vm.inventoryData.styleNo)),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "款式名称：" +
                        _vm._s(
                          _vm.multiLanguageDisplay(_vm.inventoryData.styleName)
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "品牌：" +
                        _vm._s(
                          _vm.multiLanguageDisplay(_vm.inventoryData.brand)
                        )
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { border: "", data: _vm.inventoryList } },
            [
              _vm._l(_vm.inventoryColumn, function (item, index) {
                return [
                  item.key == "colorName"
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "" + item.key,
                          label: item.title,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.multiLanguageDisplay(
                                          scope.row.colorName
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "" + item.key,
                          label: item.title,
                        },
                      }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "op-container" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("关闭"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible2 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { border: "", data: _vm.laddData } },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "name", label: "数量区间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "quantity",
                  label: "阶梯最低数量",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "price",
                  label: _vm.laddStatus == 1 ? "价格(CNY)" : "价格(USD)",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titColor" }, [
      _c("span", { staticClass: "subText" }, [
        _c("i", { staticStyle: { color: "red" } }, [_vm._v("*")]),
        _vm._v(" 颜色："),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "subText" }, [
      _c("i", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v(" 尺码："),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }